import { useMutation } from 'react-query';
import {
  createCustomerRecognitionAsync,
  getCustomerRecognitionByIdAsync,
  updateCustomerRecognitionAsync,
} from '../../index';

export const useCreateCustomerRecognitionAsync = () =>
  useMutation(createCustomerRecognitionAsync);

export const useUpdateCustomerRecognitionAsync = () =>
  useMutation(updateCustomerRecognitionAsync);

export const useGetCustomerRecognitionByIdAsync = () =>
  useMutation(getCustomerRecognitionByIdAsync);
